import React from 'react';
import Container from 'react-bootstrap/Container';
import '../../App.css';

const About = () => {
  return (
    <Container id="main-container">
      <div className="text-center p-5 w-100">
        About us
      </div>
    </Container>
  );
};

export default About;